// import React, { useEffect, useState } from 'react';
// import Navbar from '../Navbar';
// import { Link, useNavigate } from 'react-router-dom';
// import {Box, Button,Grid, TextField, Typography} from '@mui/material';
// import swal from 'sweetalert';
// import axios from 'axios';
// import EditIcon from '@mui/icons-material/Edit';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DeleteIcon from '@mui/icons-material/Delete';
// import _ from "lodash";
// // import * as swal from 'sweetalert';
// import Swal from 'sweetalert2'
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import filterFactory,{textFilter, selectFilter} from 'react-bootstrap-table2-filter';

// const pageSize = 10;

// function Customermastershow() {
//     const [loading, setLoading] = useState(true);
//   const [categorylist, setCategorylist] = useState([]);
//   const [paginated, setPaginated] = useState();
//   const [currentPage, setcurrentPage] = useState(1);

//   useEffect(()=>{
//       axios.get(`api/view-customer`).then(res=>{
//           if(res.status === 200){
//               setCategorylist(res.data.customer);
//               setPaginated(_(res.data.customer).slice(0).take(pageSize).value());
//           }
//           setLoading(false);
//       });
//   },[]);

//   function add3Dots(string, limit)
// {
//   var dots = "...";
//   if(string.length > limit)
//   {
//     // you can also use substr instead of substring
//     string = string.substring(0,limit) + dots;
//   }

//     return string;
// }

//   const deleteUser = (e, id) => {

//     e.preventDefault();

//     const thisClicked = e.currentTarget;

//         const swalWithBootstrapButtons = Swal.mixin({
//       customClass: {
//         confirmButton: 'btn btn-success',
//         cancelButton: 'btn btn-danger'
//       },
//       buttonsStyling: false
//     })

//         swalWithBootstrapButtons.fire({
//           title: 'Are you sure , you want to delete this customer',
//           text: "You won't be able to revert this!",
//           icon: 'warning',
//           showCancelButton: true,
//           confirmButtonText: 'Yes,delete it!',
//           cancelButtonText: 'No, cancel!',
//           reverseButtons: true
//         }).then((result) => {
//           if (result.isConfirmed) {
//             axios.get(`api/delete_customer/${id}`).then(res=>{
//               if(res.data.status === 200){
//             thisClicked.closest("tr").remove();
//           }
//           else if(res.data.status===404){
//             swal("Success",res.data.message,"success");
//             thisClicked.innerText = "Delete";

//           }
//          });
//             swalWithBootstrapButtons.fire(

//               'Deleted!',
//               'Customer deleted successfully.',
//               'success'
//             )
//           } else if (

//             /* Read more about handling dismissals below */
//             result.dismiss === Swal.DismissReason.cancel
//           ) {
//             // swalWithBootstrapButtons.fire(
//             //   'Cancelled',
//             //   'Your imaginary file is safe :)',
//             //   'error'
//             // )
//           }
//         })

//   }

//   const [query, setquery] = useState("");

//   var viewcategory_HTMLTABLE = "";
//   if(loading){
//     swal({
//       title: 'Loading',
//       text: 'Please Wait!!!',
//       timer: 1000,
//       buttons: false,
//     }).then(
//       function () {},
//       // handling the promise rejection
//       function (dismiss) {
//         if (dismiss === 'timer') {
//           //console.log('I was closed by the timer')
//         }
//       }
//     )
//   }
//   else{
//       viewcategory_HTMLTABLE =
//       paginated.map((item)=>{
//           return(
//               <tr key={item.id}>
//                   <td >{item.id}</td>
//                   <td sx={{ border: 1 }}>{item.name}</td>
//                   <td sx={{ border: 1 }}>{item.gstno}</td>
//                   <td sx={{ border: 1 }}>{item.pcode}</td>
//                   <td sx={{ border: 1 }}>{item.acode}</td>
//                   <td sx={{ border: 1 }}>{add3Dots(item.maddress,25)}</td>
//                   <td sx={{ border: 1 }}>{item.email}</td>
//                   <td sx={{ border: 1 }}>{add3Dots(item.address,25)}</td>
//                   <td sx={{ border: 1 }}>{item.cname}</td>
//                   <td sx={{ border: 1 }}>{item.cnamecontact}</td>
//                   {/* <td sx={{ border: 1 }}>{item.gs}</td> */}

//                   {/* <td><Link to="#" className="btn btn-success btn-sm">View</Link></td> */}
//                   <td>
//                   <Grid container spacing={2}>
//                   <Grid item xs={3}>
//                   <Button component={Link} to={`/view-customer/${item.id}`} color="primary" size="medium" startIcon={<VisibilityIcon color='inherit'/>}/>
//                   </Grid>
//                   <Grid item xs={3}>
//                   <Button component={Link} to={`/edit-customer/${item.id}`} color="primary" size="medium" startIcon={<EditIcon color='inherit'/>}/>
//                   {/* <td><Link to={`edit-customer/${item.id}`} className="btn btn-success btn-sm">Edit</Link></td> */}
//                   {/* <td><button type="button" onClick={(e) => deleteUser(e, item.id)} className="btn btn-danger bt-sm">Delete</button></td> */}
//                   </Grid>
//                   <Grid item xs={3}>
//                   <Button onClick={(e) => deleteUser(e, item.id)}  color="primary" size="medium" startIcon={<DeleteIcon color='warning'/>}/>
//                   </Grid>
//                   </Grid>
//                   </td>
//                   {/* <td><button type="button" className="btn btn-danger bt-sm">Delete</button></td> */}
//               </tr>
//           )
//       });
//   }

//   const pageCount = categorylist? Math.ceil(categorylist.length/pageSize) :0;
//   // if(pageCount === 1) return null;
//   const pages = _.range(1, pageCount+1);
//   const pagination=(pageNo)=>{
//     setcurrentPage(pageNo);
//     const startIndex = (pageNo - 1)*pageSize;
//     const paginated = _(categorylist).slice(startIndex).take(pageSize).value();
//     setPaginated(paginated);
//   }

//   return (
//     <div>
//     <Navbar/>
//     <div className = "card px-8 m-5">
//      <div className = "card-header">
//           <h4>Customer Master
//           <Link to="/add-customer" className='btn btn-primary btn-bg float-end'>Add Customer</Link>
//           </h4>
//      </div>
//      <div className="card-body">
//      <div className='table-responsive'>
//      <table className="table table-bordered" pagination={paginationFactory()}
//          filter={filterFactory()} >
//     <thead>
//       <tr>
//       <th>ID</th>
//         <th>Name</th>
//         <th>GST NO</th>
//         <th>

//         Party Code
//         </th>
//         <th>Associate Code</th>
//         <th>Mini Address</th>
//         <th>Email ID</th>
//         <th>Address</th>
//         <th>Party Contact Person</th>
//         <th>Contact Number</th>
//         {/* <th>GS</th> */}
//         <th>Actions</th>
//         {/* <th>Edit</th> */}
//         {/* <th>Delete</th> */}
//       </tr>
//       </thead>
//     <tbody>
//      {viewcategory_HTMLTABLE}
//     </tbody>

//   </table>
//   <nav className='d-flex justify-content-center'>
//     <ul className='pagination'>
//     {
//       pages.map((page)=>(
//         <li
//         className={
//           page === currentPage ? "page-item-active" : "page-item"
//         }
//         >
//         <p className='page-link'
//         onClick={()=>pagination(page)}
//         >
//         {page}
//         </p>
//         </li>

//       ))
//     }
//     </ul>
//   </nav>
// </div>
// </div>
// </div>
//     </div>

//   )
// }

// export default Customermastershow




import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import { Link, useNavigate } from 'react-router-dom';
import {Box, Button,Grid, Hidden, TextField, Typography} from '@mui/material';
import swal from 'sweetalert';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import _ from "lodash";
// import * as swal from 'sweetalert';
import Swal from 'sweetalert2';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';

import filterFactory,{textFilter, selectFilter} from 'react-bootstrap-table2-filter';
import overlayFactory from 'react-bootstrap-table2-overlay';
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";
import { removeFilterTitle } from '../../util/removeFilterTitle';

function Customermastershow() {

  //useState declarations
  const [loading, setLoading] = useState(true);
  const [categorylist, setCategorylist] = useState([]);


  useEffect(()=>{
      axios.get(`api/view-customer`).then(res=>{
          if(res.status === 200){
              setCategorylist(res.data.customer);
          }
          setLoading(false);
      });
  },[]);

  //colour palette
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  function add3Dots(string, limit) {
    var dots = "...";
    if (string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }

    return string;
  }


  const deleteUser = (e, id) => {

    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data= {user_id:userId,};

    const thisClicked = e.currentTarget;

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: true,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure , you want to delete this customer",
        text: "You won't be able to revert this!",
        icon: "warning",
        confirmButtonColor: "#D10000",
        cancelButtonColor: "#00D100",
        showCancelButton: true,
        confirmButtonText: "Yes,delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          axios.post(`api/delete_customer/${id}`,data).then((res) => {
            if (res.data.status === 200) {
              thisClicked.closest("tr").remove();
            } else if (res.data.status === 404) {
              swal("Success", res.data.message, "success");
              thisClicked.innerText = "Delete";
            }
          });
          swalWithBootstrapButtons.fire(
            "Deleted!",
            "Customer deleted successfully.",
            "success"
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          // swalWithBootstrapButtons.fire(
          //   'Cancelled',
          //   'Your imaginary file is safe :)',
          //   'error'
          // )
        }
      });
  };

  // remove filter title
  useEffect(()=>{
   
    removeFilterTitle(".sr-only")
  }, [])

  //pagination
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      . Showing {from} to {to} of {size} Results"
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: categorylist.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  var add = add3Dots("address", 25);
  const ans = add3Dots("address", 25);

  //columns of table
  const columns = [
    {
      dataField: "id",
      text: "ID",
      headerStyle: (colum, colIndex) => {
        return {  width: '50px' };
      }
      
    },
    {
      dataField: "name",
      text: "Party Name",
      headerStyle: (colum, colIndex) => {
        return {  textAlign: 'center' };
      }
    },
    {
      dataField: "gstno",
      text: "GST No",
    },
    {
      dataField: "pcode",
      text: "Party Code",
      filter: textFilter(),
      headerStyle: (colum, colIndex) => {
        return {  textAlign: 'center' };
      }
    },
    {
      dataField: "acode",
      text: "Associate Code",
      filter: textFilter(),
      //   header: 'hello',

      // }),
    },
    {
      dataField: "maddress",
      text: "Mini Address",
      headerStyle: (colum, colIndex) => {
        return {  textAlign: 'center' };
      }
    },
    {
      dataField: "email",
      text: "Email",
      headerStyle: (colum, colIndex) => {
        return {  textAlign: 'center' };
      }
    },
    {
      dataField: "address",
      text: "Address",
      // style: {overflow : Hidden }
    },
    {
      dataField: "cname",
      text: "Party Contact Person",
      headerStyle: (colum, colIndex) => {
        return { textAlign: 'center' };
      }
    },
    {
      dataField: "cnamecontact",
      text: "Contact Number",
    },
    {
      dataField: 'action',
      text: 'Actions',
      formatter:  (cell, row, rowIndex, formatExtraData) => { 
        // console.log(row);
        const customerId = row.id;
        // console.log(customerId);


        return (
          <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
          <Grid item xs={3}>

           <Button component={Link} to={`/certificates/view-customer/${customerId}`} color="apple" size="medium" startIcon={<VisibilityIcon color='inherit'/>}/>
          </Grid>
           <Grid item xs={3}>
          <Button component={Link} to={`/certificates/edit-customer/${customerId}`} color="apple" size="medium" startIcon={<EditIcon color='inherit'/>}/>
          {/* <td><Link to={`edit-customer/${item.id}`} className="btn btn-success btn-sm">Edit</Link></td> */}
          {/* <td><button type="button" onClick={(e) => deleteUser(e, item.id)} className="btn btn-danger bt-sm">Delete</button></td> */}
          </Grid>
          <Grid item xs={3}>
          <Button onClick={(e) => deleteUser(e, customerId )}  color="error" size="medium" startIcon={<DeleteIcon color='warning'/>}/>
          </Grid>
           </Grid>
           </ThemeProvider>
        )
      },
    },
  ];
  

  return (
    <div>
    <Navbar/>
    <div className = "card px-8 m-5">
      <div className = "card-header">
      <div class="d-flex justify-content-between">
           <h4>Customer Master
           </h4>
           <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/add-customer" variant='contained' color='apple'>Add Customer</Button>
           </ThemeProvider>
      </div>
      </div>
      <BootstrapTable keyField='id' data={categorylist} columns={columns} hover condensed
        // pagination={paginationFactory(options)}
        filter={filterFactory()}
        
      />
    </div>
    </div>
    
  )
}

export default Customermastershow

